import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "antd";
import { UserGet } from "../../Api/CoreApi";
import {
  FaWhatsapp, FaUsers, FaGift, FaShareAlt, FaHeart,
} from "react-icons/fa";
import ProfileHeader from "./Profile_Header";
import Footer from "../../Home_Page_WLog/Footer/Footer";

function User_Added_User() {
  const navigate = useNavigate();
  const [user, setUser] = useState([]);
  const [staff, setStaff] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    typeof window !== "undefined" ? window.innerWidth > 768 : true
  );

  const userId = localStorage.getItem("user_id");
  const user_role = localStorage.getItem("role");

  const permission = () => {
    if (!userId || user_role !== "user") { navigate("/"); }
  };

  const staffref = staff.map((i) => i.refer);

  const get = async () => {
    try {
      const staffResponse = await UserGet();
      const currentStaff = staffResponse.filter(
        (i) => String(i.id) === String(userId)
      );
      setStaff(currentStaff);
      if (currentStaff.length === 0) return;
      const userData = staffResponse.filter(
        (i) => i.ref === currentStaff[0].refer
      );
      setUser(userData);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  useEffect(() => { permission(); get(); }, []);

  useEffect(() => {
    const handleResize = () => setIsSidebarOpen(window.innerWidth > 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns = [
    {
      title: "No.",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      render: (_text, _record, index) => (
        <span className="au-index">{index + 1}</span>
      ),
      width: 70,
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
      render: (text, record) => (
        <div className="au-name-cell">
          <div className="au-avatar">
            {record.username ? record.username.charAt(0).toUpperCase() : "U"}
          </div>
          <span>{record.username || "N/A"}</span>
        </div>
      ),
    },
    {
      title: "District",
      dataIndex: "district",
      key: "district",
      sorter: (a, b) => (a.district || "").localeCompare(b.district || ""),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: (a, b) => (a.state || "").localeCompare(b.state || ""),
    },
  ];

  return (
    <>
      {/* ✅ CSS style tag */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');
        * { font-family: 'Poppins', sans-serif !important; box-sizing: border-box; }

        @keyframes auFloat {
          0%,100% { transform: translateY(0) rotate(0deg) scale(1); }
          50% { transform: translateY(-18px) rotate(6deg) scale(1.08); }
        }
        @keyframes auShimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        @keyframes auBeat {
          0%,100% { transform: scale(1); }
          25% { transform: scale(1.12); }
          50% { transform: scale(1); }
          75% { transform: scale(1.12); }
        }

        .au-page {
          min-height: 100vh;
          background: linear-gradient(180deg, #fff 0%, #fff5f7 50%, #fff 100%);
          position: relative;
          overflow-x: hidden;
        }

        .au-float {
          position: absolute;
          opacity: 0.14;
          animation: auFloat 6s ease-in-out infinite;
          pointer-events: none;
          z-index: 1;
          filter: drop-shadow(0 4px 8px rgba(255,0,85,0.12));
        }

        .au-wrap {
          max-width: 1180px;
          margin: 0 auto;
          padding: 88px 16px 40px;
          position: relative;
          z-index: 2;
        }

        .au-hero {
          position: relative;
          overflow: hidden;
          border-radius: 28px;
          background: linear-gradient(135deg, #ff0044 0%, #ff3366 25%, #ff6699 55%, #ff99b5 78%, #ffc2d4 100%);
          padding: 34px 28px;
          box-shadow: 0 20px 50px rgba(255,0,85,0.12);
          margin-bottom: 26px;
        }

        .au-hero::before {
          content: "";
          position: absolute;
          inset: 0;
          background:
            radial-gradient(circle at 20% 40%, rgba(255,255,255,0.12), transparent 45%),
            radial-gradient(circle at 80% 20%, rgba(255,255,255,0.08), transparent 40%);
          pointer-events: none;
        }

        .au-hero-inner {
          position: relative;
          z-index: 2;
          text-align: center;
          max-width: 760px;
          margin: 0 auto;
        }

        .au-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 9px 18px;
          border-radius: 999px;
          background: rgba(255,255,255,0.16);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255,255,255,0.28);
          color: #fff;
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 16px;
        }

        .au-title {
          font-size: clamp(28px, 4vw, 42px);
          font-weight: 900;
          color: #fff;
          line-height: 1.15;
          margin: 0 0 10px;
        }

        .au-title span {
          background: linear-gradient(90deg, #fff, #ffe4ec, #fff0f5);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .au-subtitle {
          color: rgba(255,255,255,0.92);
          font-size: 14px;
          line-height: 1.8;
          margin: 0 auto;
          max-width: 620px;
        }

        .au-summary-grid {
          display: grid;
          grid-template-columns: 1.1fr 1fr;
          gap: 20px;
          margin-bottom: 24px;
        }

        .au-summary-card {
          background: #fff;
          border: 2px solid #ffe4ec;
          border-radius: 24px;
          box-shadow: 0 10px 30px rgba(255,0,85,0.06);
          overflow: hidden;
          transition: all 0.35s ease;
        }

        .au-summary-card:hover {
          transform: translateY(-4px);
          border-color: #ff9fbe;
          box-shadow: 0 18px 40px rgba(255,0,85,0.12);
        }

        .au-summary-topbar {
          height: 6px;
          background: linear-gradient(90deg, #ff0055, #ff4d88, #ff80aa, #ff0055);
          background-size: 200% 100%;
          animation: auShimmer 3.2s linear infinite;
        }

        .au-summary-body {
          padding: 20px 22px;
        }

        .au-summary-head {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .au-summary-icon {
          width: 46px;
          height: 46px;
          border-radius: 14px;
          background: linear-gradient(135deg, #ff0055, #ff4d88);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 18px;
          box-shadow: 0 8px 18px rgba(255,0,85,0.18);
          flex-shrink: 0;
        }

        .au-summary-head h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 800;
          color: #1a0a10;
        }

        .au-summary-head p {
          margin: 3px 0 0;
          font-size: 12.5px;
          color: #999;
          font-weight: 500;
        }

        .au-stat-row {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
          margin-top: 10px;
        }

        .au-stat-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 8px 14px;
          border-radius: 999px;
          background: linear-gradient(135deg, #fff0f3, #ffe4ec);
          border: 1.5px solid #ffd3df;
          color: #ff0055;
          font-size: 12px;
          font-weight: 700;
        }

        .au-share-link-box {
          padding: 14px 16px;
          border-radius: 16px;
          background: linear-gradient(135deg, #fffafc, #fff0f3);
          border: 1.5px solid #ffe4ec;
          color: #555;
          font-size: 13px;
          line-height: 1.6;
          word-break: break-all;
          margin-top: 10px;
        }

        .au-share-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 13px 20px;
          background: linear-gradient(135deg, #25D366, #1EBE54);
          color: #fff;
          border-radius: 14px;
          text-decoration: none;
          font-weight: 700;
          font-size: 14px;
          margin-top: 14px;
          box-shadow: 0 10px 24px rgba(37,211,102,0.24);
          transition: all 0.35s ease;
          width: fit-content;
        }

        .au-share-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 14px 28px rgba(37,211,102,0.30);
          color: #fff;
        }

        .au-table-card {
          background: #fff;
          border: 2px solid #ffe4ec;
          border-radius: 24px;
          box-shadow: 0 12px 34px rgba(255,0,85,0.06);
          overflow: hidden;
        }

        .au-table-topbar-pink {
          height: 6px;
          width: 100%;
          background: linear-gradient(90deg, #ff0055, #ff4d88, #ff80aa);
        }

        .au-table-header {
          padding: 22px 22px 12px;
        }

        .au-table-header h2 {
          margin: 0 0 6px;
          font-size: 24px;
          font-weight: 800;
          color: #1a0a10;
        }

        .au-table-header p {
          margin: 0;
          color: #888;
          font-size: 14px;
        }

        .au-custom-table .ant-table-thead > tr > th {
          background: #fff8fa !important;
          color: #c2185b !important;
          font-weight: 700 !important;
          font-size: 13px !important;
          border-bottom: 1px solid #ffe4ec !important;
        }

        .au-custom-table .ant-table-tbody > tr > td {
          border-bottom: 1px solid #fff0f3 !important;
          font-size: 13.5px !important;
          color: #555 !important;
        }

        .au-custom-table .ant-table-tbody > tr:hover > td {
          background: #fff7fa !important;
        }

        .au-index { font-weight: 700; color: #ff0055; }

        .au-name-cell {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .au-avatar {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background: linear-gradient(135deg, #ff0055, #ff4d88);
          color: #fff;
          font-weight: 700;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .au-empty {
          text-align: center;
          padding: 56px 20px;
        }

        .au-empty-icon {
          font-size: 54px;
          display: block;
          margin-bottom: 12px;
          animation: auBeat 2s infinite;
        }

        .au-empty h3 { margin: 0 0 8px; color: #c2185b; font-size: 22px; font-weight: 700; }
        .au-empty p { margin: 0; color: #999; font-size: 14px; }

        @media (max-width: 900px) {
          .au-summary-grid { grid-template-columns: 1fr; }
        }

        @media (max-width: 600px) {
          .au-wrap { padding: 76px 12px 30px; }
          .au-hero { padding: 24px 18px; border-radius: 20px; }
          .au-title { font-size: 28px; }
          .au-summary-body { padding: 16px 14px; }
          .au-table-header { padding: 18px 16px 10px; }
          .au-table-header h2 { font-size: 20px; }
        }
      `}</style>

      {/* ✅ Header */}
      <ProfileHeader />

      <div className="au-page">
        {/* Floating emojis */}
        {["💖","💍","💕","🌹","✨","❤️"].map((e, i) => (
          <span key={i} className="au-float" style={{
            top: `${10+((i*9)%68)}%`,
            left: `${5+((i*13)%82)}%`,
            fontSize: `${16+(i%4)*4}px`,
            animationDelay: `${i*0.4}s`,
          }}>{e}</span>
        ))}

        <div className="au-wrap">
          {/* Hero */}
          <section className="au-hero">
            <div className="au-hero-inner">
              <div className="au-badge"><FaHeart /> Referral & Network Growth</div>
              <h1 className="au-title">Users Added By <span>You</span></h1>
              <p className="au-subtitle">
                Share your referral link, grow your network, and track users connected through your profile.
              </p>
            </div>
          </section>

          {/* Summary Cards */}
          <div className="au-summary-grid">
            <div className="au-summary-card">
              <div className="au-summary-topbar"></div>
              <div className="au-summary-body">
                <div className="au-summary-head">
                  <div className="au-summary-icon"><FaUsers /></div>
                  <div>
                    <h3>Your Referral Network</h3>
                    <p>Users linked through your referral</p>
                  </div>
                </div>
                <div className="au-stat-row">
                  <div className="au-stat-pill"><FaUsers /> {user.length} Added Users</div>
                  <div className="au-stat-pill"><FaGift /> Earn & Share</div>
                </div>
              </div>
            </div>

            <div className="au-summary-card">
              <div className="au-summary-topbar"></div>
              <div className="au-summary-body">
                <div className="au-summary-head">
                  <div className="au-summary-icon"><FaShareAlt /></div>
                  <div>
                    <h3>Share Your Link</h3>
                    <p>Invite others and expand your connections</p>
                  </div>
                </div>
                <div className="au-share-link-box">
                  https://communityrishtey.com/User_Reg/{staffref}
                </div>
                <a
                  href={`https://wa.me/?text=${encodeURIComponent(
                    `https://communityrishtey.com/User_Reg/${staffref}`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="au-share-btn"
                >
                  <FaWhatsapp style={{ fontSize: "18px" }} />
                  Share & Earn
                </a>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="au-table-card">
            <div className="au-table-topbar-pink"></div>
            <div className="au-table-header">
              <h2>Added Users List</h2>
              <p>Users who registered using your referral connection</p>
            </div>
            <Table
              columns={columns}
              dataSource={user}
              rowKey="id"
              bordered={false}
              pagination={{ pageSize: 10 }}
              scroll={{ x: true }}
              className="au-custom-table"
              locale={{
                emptyText: (
                  <div className="au-empty">
                    <span className="au-empty-icon">💌</span>
                    <h3>No Added Users Yet</h3>
                    <p>Share your referral link to start growing your network.</p>
                  </div>
                ),
              }}
            />
          </div>
        </div>
      </div>

      <Footer />
    </>   // ✅ Closing fragment
  );
}

export default User_Added_User;